// src/components/Spinner.js
import React from "react";
import { motion } from "framer-motion";

const Spinner = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
      style={{
        width: "50px",
        height: "50px",
        border: "5px solid rgba(0, 0, 0, 0.2)",
        borderTop: "5px solid #d32f2f", // Color del borde superior
        borderRadius: "50%",
        margin: "0 auto",
        animation: "spin 1s linear infinite",
      }}
    />
  );
};

export default Spinner;
